<template>
  <div>
    <el-upload
      class="upload-demo"
      ref="upload"
      :action="action"
      :file-list="fileList"
      :auto-upload="autoUplaod"
    
      :show-file-list="false"
      accept="image/*"
      :on-success="onSuccess"
      :on-error="onError"
      :before-upload="beforeAvatarUpload"
    >
      <el-button slot="trigger" size="small" type="primary" :loading="loading">选取文件</el-button>
    </el-upload>
    <div v-if="tmpUrl || imgUrl">
      <el-image
        style="width: 200px; height: 200px"
        fit="cover"
        :src="tmpUrl || imgUrl || require('@/assets/avatar.png')"
        :preview-src-list="[tmpUrl || imgUrl]"
      >
        <div slot="error">
          <el-image
            style="width: 200px; height: 200px"
            fit="cover"
            :src="require('@/assets/avatar.png')"
          />
        </div>
      </el-image>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImgUpload',
  model: {
    prop: 'imgUrl',
    event: 'setNewUrl'
  },
  props: {
    autoUplaod: {
      type: Boolean,
      default: true
    },
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      action: `${process.env.VUE_APP_BASE_API}/api/web/uploadFile/upload`,
      loading: false,
      tmpUrl: '',
      fileList: [
        // {
        //   name: 'food.jpeg',
        //   url:
        //     'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        // }
      ]
    }
  },
  created(){

  },
  methods: {
    submitUpload() {
      this.loading=true
      this.$refs.upload.submit()
    },
    onSuccess(response) {
      this.loading = false
      this.tmpUrl = response.data.url
      this.$emit('setNewUrl', response.data.imageUrl)
    },
    onError() {
      this.$message.error('上传失败')
      this.loading = false
       this.$emit("getLoading",false)
    },
    beforeAvatarUpload(file) {
      console.log(file)
   
      this.loading = true
      const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isLt2M) {
      //   this.$message.error('上传图片大小不能超过 2MB!')
      //   this.loading = false
      // }
    this.$emit("getLoading",true)
      return isLt2M
    }
  }
}
</script>
